import api from "../../../../utils/api";
const apiUrl = process.env.REACT_APP_MOCK_RESUME_URL;

export const getPaymentReport = async (month, year, currency = "INR", startDate = null, endDate = null) => {
    try {
        const params = new URLSearchParams({
            month: month.toString(),
            year: year.toString(),
            currency: currency === "INR" ? "INR" : "usd"
        });
        if (startDate) {
            params.append('startDate', startDate);
        }
        
        if (endDate) {
            params.append('endDate', endDate);
        }

        const res = await api.get(
            `/payments/getPaymentReport?${params.toString()}`,
            {
                baseURL: apiUrl
            }
        );
        return res;
    } catch (err) {
        return err;
    }
};


export const fetchExternalLists = async (
  page = 0, 
  limit = 10, 
  invoiceType = 'standard', 
  companyName = '', 
  duration = '', 
  startDate = '', 
  endDate = '',
  currency = 'INR',
  month = null,
  year = null
) => {
  try {
    const invoiceTypeMapping = {
      'standard': 'standard',
      'tax': 'taxbased'
    };
    
    const mappedInvoiceType = invoiceTypeMapping[invoiceType] || 'standard';
    let queryParams = `page=${page + 1}&size=${limit}&invoiceType=${mappedInvoiceType}`;
    
    if (companyName && companyName.trim()) {
      queryParams += `&companyName=${encodeURIComponent(companyName.trim())}`;
    }  
    if (duration && duration.trim()) {
      queryParams += `&duration=${encodeURIComponent(duration)}`;
    }  
    if (startDate && startDate.trim()) {
      queryParams += `&startDate=${encodeURIComponent(startDate)}`;
    }
    if (endDate && endDate.trim()) {
      queryParams += `&endDate=${encodeURIComponent(endDate)}`;
    }
    if (currency) {
      queryParams += `&currency=${encodeURIComponent(currency)}`;
    }
    if (month !== null && month !== undefined) {
      queryParams += `&month=${month}`;
    }
    if (year !== null && year !== undefined) {
      queryParams += `&year=${year}`;
    }
    
    const res = await api.get(
      `/payments/customInvoice?${queryParams}`,
      {
        baseURL: apiUrl
      }
    );
    return res;
  } catch (err) {
    return err;
  }
};


export const getSubscriedUsers = async (
  page, 
  limit, 
  tab, 
  paymentFor = '', 
  currency = 'INR', 
  startDate = '', 
  endDate = '', 
  month = null, 
  year = null
) => {
  try {
    let queryParams = `sortBy=created_at&orderBy=desc&page=${page}&limit=${limit}`;

    if (tab === "MONTHLY" || tab === "YEARLY") {
      queryParams += `&interval=${tab}`;
    } else if (tab === "ONETIME_SUBSCRIPTION" || tab === "ADDON" || tab === "ONE_TIME") {
      queryParams += `&type=${tab}`;
      if (tab === "ONE_TIME") {
        queryParams += `&platFormPayment=true`;
      }
      if (tab === "ADDON" && paymentFor && paymentFor.trim() !== '') {
        queryParams += `&payment_for=${paymentFor}`;
      }
    }
    if (currency) {
      queryParams += `&currency=${encodeURIComponent(currency)}`;
    }
    if (startDate && startDate.trim()) {
      queryParams += `&startDate=${encodeURIComponent(startDate)}`;
    }
    if (endDate && endDate.trim()) {
      queryParams += `&endDate=${encodeURIComponent(endDate)}`;
    }
    if (month !== null && month !== undefined) {
      queryParams += `&month=${month}`;
    }
    if (year !== null && year !== undefined) {
      queryParams += `&year=${year}`;
    }
    const res = await api.get(`/customers/user/get-subscribed-users?${queryParams}`, {
      baseURL: apiUrl,
    });

    return res;
  } catch (err) {
    return err;
  }
};